import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTickets } from "./TicketContext";
const times = [
  "9:00AM",
  "10:00AM",
  "11:00AM",
  "12:00PM",
  "1:00PM",
  "2:00PM",
  "3:00PM",
  "4:00PM",
];

export default function TimeSelection() {
  const [selectedTime, setSelectedTime] = useState(null);
  const navigate = useNavigate();
  const { tickets, setTickets, totalTickets, totalPrice } = useTickets();

  return (
    <div className="flex flex-col items-center justify-center p-4 pb-24 bg-[#f8f5eb] min-h-screen">

      <div className="grid w-full grid-cols-1 gap-4 md:grid-cols-2 md:px-44">

      <div className="relative w-full overflow-hidden bg-white rounded-xl">
      <div className="flex flex-col items-center w-full ">
        <div className="w-full">
          {times.map((time, index) => (
            <div
              key={index}
              onClick={() => setSelectedTime(time)}
              className={`flex justify-between items-center p-5   border-b cursor-pointer transition text-lg ${
                selectedTime === time
                  ? "bg-black text-white"
                  : "bg-white hover:bg-gray-100"
              }`}
            >
              <span className="font-semibold">{time}</span>
              <span className={selectedTime === time ? "text-white" : "text-gray-600"}>
                Available
              </span>
            </div>
          ))}
        </div>

        
      </div>
      </div>

       

      <div className="w-full max-w-md p-6 mt-4 bg-white md:mt-0 h-fit rounded-xl">
        <h2 className="mb-5 text-lg font-bold text-green-900 font-georgia">Total Payable</h2>
        <p className="text-xl font-bold text-gray-900 font-georgia">S${totalPrice}.00</p>
        <p className="text-sm text-gray-600 font-georgia">Inclusive of 9% GST S$ 3.55</p>
        <div className="pt-3 mt-3 border-t">
          <h3 className="mt-5 mb-5 text-lg font-bold text-gray-800 font-georgia">Admissions</h3>
          <p className="text-gray-700 text-md font-georgia">Rainforest Wild ASIA Admission</p>
          <div className="flex justify-between mt-2 font-semibold text-md font-georgia">
            <span>Adult (Non-resident)</span>
            <span>x {totalTickets}</span>
            <span>S${totalPrice}.00</span>
          </div>
        </div>
      </div>

      </div>

      <div className="fixed bottom-0 flex justify-end w-full p-4 mt-4 bg-white">
        <button
          onClick={() => navigate(-1)}
          className="mr-10 text-gray-700 font-georgia text-md hover:underline"
        >
          Back
        </button>
        <button
          onClick={() => navigate("/4")}
          disabled={!selectedTime}
          className={`px-6 py-2 text-white font-bold rounded-full shadow text-md font-georgia   ${
            selectedTime ? "bg-black" : "bg-gray-400 cursor-not-allowed"
          }`}
        >
          NEXT
        </button>
      </div>

    </div>
  );
}











